import { useState, useEffect } from "react";
import './styles.js';
import { Container, Content } from "./styles.js";
import Load from "../../../../../components/load/index.js";
import MovieTmdb from "../../../../../components/movie/person/tmdb/movie.js";

export default function MoviesTmdb({ person_id, movieType, filters }) {

    const [movies, setMovies] = useState([]);
    const [loadingMovies, setLoadingMovies] = useState(true);

    useEffect(() => {
        const fetchMovies = async () => {
            setLoadingMovies(true);
    
            try {
                const response = await fetch(
                    `https://api.themoviedb.org/3/person/${person_id}/combined_credits?api_key=${process.env.REACT_APP_TMDB_KEY}&language=pt-BR`
                );
                const data = await response.json();
            
                if (data.cast) {
                    let filteredMovies = data.cast;
            
                    // Filtra filmes sem poster_path, overview ou vote_average
                    filteredMovies = filteredMovies.filter(
                        (movie) => movie.poster_path && movie.overview && movie.vote_average
                    );
            
                    // Filtra os filmes por ano
                    if (filters.minYear) {
                        filteredMovies = filteredMovies.filter(
                            (movie) => movie.release_date && parseInt(movie.release_date.split("-")[0]) >= filters.minYear
                        );
                    }
                    if (filters.maxYear) {
                        filteredMovies = filteredMovies.filter(
                            (movie) => movie.release_date && parseInt(movie.release_date.split("-")[0]) <= filters.maxYear
                        );
                    }
            
                    // Ordena os filmes por data ou avaliação
                    if (filters.sortBy === "release_date") {
                        filteredMovies = filteredMovies.sort((a, b) => {
                            const yearA = new Date(a.release_date).getFullYear();
                            const yearB = new Date(b.release_date).getFullYear();
                            return filters.yearOrder === "asc" ? yearA - yearB : yearB - yearA;
                        });
                    } else if (filters.sortBy === "vote_average") {
                        filteredMovies = filteredMovies.sort((a, b) => {
                            return filters.ratingOrder === "asc"
                                ? a.vote_average - b.vote_average
                                : b.vote_average - a.vote_average;
                        });
                    }
            
                    setMovies(filteredMovies);
                } else {
                    setMovies([]);
                }
            } catch (error) {
                console.error("Erro ao buscar dados do TMDb:", error);
                setMovies([]);
            } finally {
                setLoadingMovies(false);
            }            
            
        };
    
        fetchMovies();
    }, [person_id, movieType, filters]);    

    return (
        <Container>
            <MovieTmdb movies={movies} mediaType={movieType}/>
            {!loadingMovies && (!movies || movies?.length < 1) && (
                <div>
                    <span>Nenhum resultado</span>
                </div>
            )}
        </Container>
    );
}
